// Telas do app que a notificação pode abrir (valor de data.screen).
// Fonte: _navigateFromData em ~/Flutter/meu_negocio/lib/services/messaging_service.dart.
//
// Para adicionar uma tela: incluir o destino no roteamento do app, publicar, e
// acrescentar uma linha aqui com o minAppVersion dessa versão. O app ignora
// screen desconhecido, então versões antigas só abrem o app.

export interface PushScreen {
  value: string;
  label: string;
  group: string;
  /** Primeira versão do app que conhece a tela. Sem valor = já existe na 1.11.0. */
  minAppVersion?: string;
}

/** Versão do app que traz as telas novas da F5. */
const V1_12 = '1.12.0';

export const PUSH_SCREENS: PushScreen[] = [
  { value: 'home', label: 'Início', group: 'Tela inicial', minAppVersion: V1_12 },
  { value: 'os', label: 'Ordens de serviço (aba)', group: 'Tela inicial' },
  { value: 'history', label: 'Histórico de vendas (aba)', group: 'Tela inicial' },
  { value: 'menuOrder', label: 'Pedidos do cardápio (aba)', group: 'Tela inicial' },

  { value: 'finance', label: 'Financeiro — Dashboard', group: 'Financeiro', minAppVersion: V1_12 },
  { value: 'financeAccounts', label: 'Financeiro — Contas a pagar e receber', group: 'Financeiro', minAppVersion: V1_12 },
  { value: 'financeFixed', label: 'Financeiro — Contas fixas', group: 'Financeiro', minAppVersion: V1_12 },
  { value: 'financeDre', label: 'Financeiro — DRE / Fluxo de caixa', group: 'Financeiro', minAppVersion: V1_12 },

  { value: 'newSale', label: 'Nova venda', group: 'Criar', minAppVersion: V1_12 },
  { value: 'newServiceOrder', label: 'Nova ordem de serviço', group: 'Criar', minAppVersion: V1_12 },
  { value: 'newProduct', label: 'Cadastrar novo produto', group: 'Criar', minAppVersion: V1_12 },
  { value: 'newCustomer', label: 'Cadastrar novo cliente', group: 'Criar', minAppVersion: V1_12 },

  // registerProduct/registerCostumer existem na 1.11.0, mas lá abrem sem barra superior (corrigido na 1.12).
  { value: 'registerProduct', label: 'Cadastros — Produtos', group: 'Cadastros' },
  { value: 'registerCostumer', label: 'Cadastros — Clientes', group: 'Cadastros' },
  { value: 'registerCategories', label: 'Cadastros — Categorias', group: 'Cadastros', minAppVersion: V1_12 },
  { value: 'registerServices', label: 'Cadastros — Serviços', group: 'Cadastros', minAppVersion: V1_12 },
  { value: 'registerSuppliers', label: 'Cadastros — Fornecedores', group: 'Cadastros', minAppVersion: V1_12 },
  { value: 'chartAccounts', label: 'Cadastros — Plano de contas', group: 'Cadastros', minAppVersion: V1_12 },
  { value: 'payMethod', label: 'Formas de pagamento', group: 'Cadastros' },

  { value: 'planRenew', label: 'Renovar assinatura', group: 'Plano', minAppVersion: V1_12 },
  { value: 'planUpgrade', label: 'Upgrade de plano', group: 'Plano', minAppVersion: V1_12 },

  { value: 'digitalMenu', label: 'Catálogo digital', group: 'Outras' },
  { value: 'goals', label: 'Metas', group: 'Outras', minAppVersion: V1_12 },
  { value: 'pending', label: 'Pendentes', group: 'Outras' },

  { value: 'config', label: 'Configurações', group: 'Configurações' },
  { value: 'saleConfig', label: 'Configurações de venda', group: 'Configurações' },
  { value: 'generalConfig', label: 'Configurações gerais', group: 'Configurações' },
  { value: 'whatsappConfig', label: 'Configuração do WhatsApp', group: 'Configurações' },

  { value: 'contact', label: 'Fale conosco', group: 'Suporte' },
  { value: 'message', label: 'Mensagens do suporte', group: 'Suporte' },
  { value: 'bugReport', label: 'Reportar problema', group: 'Suporte' },
  { value: 'bugReportList', label: 'Meus reportes', group: 'Suporte' },
];

export const findPushScreen = (value: string): PushScreen | undefined =>
  PUSH_SCREENS.find(screen => screen.value === value);

/** Grupos na ordem em que aparecem na lista acima. */
export const PUSH_SCREEN_GROUPS: string[] = PUSH_SCREENS.reduce<string[]>(
  (groups, screen) => (groups.includes(screen.group) ? groups : [...groups, screen.group]),
  []
);
